import history from '../../component/history';

const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

const setCookie = (name, value, days = 7) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax; Secure";
};

const eraseCookie = (name) => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax; Secure';
};

export const getUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    else return null;
}

// return the token from cookies or localStorage
export const getToken = () => {
    return localStorage.getItem('token') || getCookie('token');
}

// remove the token and user from the session storage
export const removeUserSession = () => {
    removeUserSaveSession();
    history.push('/login');
}

export const removeUserSaveSession = () => {
    eraseCookie('token');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
}

// set the token and user from cookies / local storage
export const setUserSession = (token, user) => {
    setCookie('token', token, 7);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
}

// set the token and user from the session storage
export const pushHistory = (path) => {
    history.push('/');
}
